import React from "react";
import { IntroVideo } from "components/IntroVideo";
import { Header } from "components/header";
import "./IntroVideoScreen.scss"
import { Button } from "components/button";
import { MovingfulExperienceCard } from "components/movingfulExperienceCard";
import { navigate } from "@reach/router";
import { CardLayout } from "components/cardLayout";

export interface IntroVideoScreenProps {
    path?: string;
}

export interface IntroVideoScreenState {

}

class IntroVideoScreen extends React.Component<IntroVideoScreenProps, IntroVideoScreenState> {
    constructor(props: IntroVideoScreenProps) {
        super(props);
        this.state = {};

    }

    getStarted() {
        navigate("/move?question=bookingdetails")
    }

    render() {
        return (
            <div className="todo-container">
                <div className={"paperContainer"} style={{height:window.innerHeight-160}}>
                <CardLayout>
                        <IntroVideo />
                        <MovingfulExperienceCard />
                    </CardLayout>
             </div>
             <Button
                text={"Continue"}
                onClick={() => this.getStarted()}
            />
            </div>

        );
    }
}

export default IntroVideoScreen;